export const URL_OPENREC_TV: string = process.env.REACT_APP_OPENREC_TV ?? ''
